module.exports = "<p>\n  lwf-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/organisation-profile/lwf/lwf-form/lwf-form.component.html
// module id = ./src/app/hrms/payroll/organisation-profile/lwf/lwf-form/lwf-form.component.html
// module chunks = main